export const notice = [
    {noticeNum : 1, noticeTitle : 'DoctorInHome app release guide', noticeWriter : 'DoctorInHome', noticeRdcnt : 0, noticeDate : '2024-04-18', noticeContent : `
                <img src="${require('@/assets/images/item-3.png')}" alt="DoctorInHome app image" class="centered-image">
            `},
]